import {useState} from 'react';
import {I18n} from 'aws-amplify/utils';
import {Badge} from '@mantine/core';
import {AiOutlineFilter} from 'react-icons/ai';
import {FlexiButton} from '@flexinet/ui-components';

import {useDnsRecordsFilter} from '../hooks/useDnsRecordsQuery';
import {useRecordWriteCapabilities} from '../hooks/useRecordWriteCapabilities';
import {FilterDrawer} from '../drawers/FilterDrawer';

// Reads the module-scoped store directly, which is the whole reason that store
// exists — the button, the drawer and the list hook are three different
// components.
//
// ⚠️ THE FILTER IS NOT A WRITE CONTROL and is NOT hidden for a read-only
// connection. Reading a zone's delegation is exactly what a read-only
// credential is for; hiding the filter would remove the module's most useful
// read affordance from the tenants most likely to need it.
export const FilterRecordsButton = (
    {
        connectionId,
    }: {
        connectionId?: string,
    },
) => {

    const [opened, setOpened] = useState(false);
    const {filters} = useDnsRecordsFilter();

    // The type list comes from the connection's own capability snapshot where
    // it reported one, so the filter never offers a type the provider does not
    // serve.
    const {supportedRecordTypes} = useRecordWriteCapabilities(connectionId);

    // Empty values are never stored (see FilterForm), so a key present here is
    // a filter genuinely narrowing the table.
    const activeCount = Object.keys(filters).length;

    return (
        <>
            <div style={{position: 'relative'}}>
                <FlexiButton
                    leftSection={<AiOutlineFilter/>}
                    onClick={() => setOpened(true)}
                >
                    {I18n.get('Filter')}
                </FlexiButton>
                {activeCount > 0 && (
                    <Badge
                        size={'xs'}
                        variant={'filled'}
                        color={'blue'}
                        style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 16,
                            height: 16,
                            padding: 0,
                        }}
                    >
                        {activeCount}
                    </Badge>
                )}
            </div>
            <FilterDrawer
                recordTypes={supportedRecordTypes}
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
